const wait = (delayMs) =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });

export const canMutatePaymentIntent = ({
  capturedPayment,
  paymentFinalizing
}) => !capturedPayment && !paymentFinalizing;

export const completeCapturedBooking = async ({
  complete,
  shouldContinue,
  waitForRetry = wait,
  initialDelayMs = 500,
  maxDelayMs = 5000
}) => {
  let attempt = 0;
  let lastError;

  while (shouldContinue()) {
    try {
      const response = await complete();

      if (response?.data) {
        return response;
      }

      lastError = new Error('Booking completion returned no data');
    } catch (error) {
      lastError = error;
    }

    if (!shouldContinue()) {
      break;
    }

    const delayMs = Math.min(initialDelayMs * 2 ** attempt, maxDelayMs);
    attempt += 1;
    await waitForRetry(delayMs);
  }

  throw lastError || new Error('Booking completion stopped before succeeding');
};
